import { render, staticRenderFns } from "./row.vue?vue&type=template&id=44cb8752&scoped=true&"
import script from "./row.vue?vue&type=script&lang=ts&"
export * from "./row.vue?vue&type=script&lang=ts&"
import style0 from "./row.vue?vue&type=style&index=0&id=44cb8752&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cb8752",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VRow,VTooltip})
